import React from "react";
import { Route, Routes } from "react-router-dom";
import MainHeader from "./Components/Header";
import MainNav from "./Components/MainNav";
import { useUser } from "../../DataProvider";
import PaymentMethods from "../PaymentMethods";
import Languages from "../Languages";
import Features from "../Features";
import Questions from "../Questions";
import BettingWebsites from "../BettingWebsites";
import Articles from "../Articles";
import Top10Articles from "../Top10Articles";
import MainWebsites from "../MainWebsites/page";

type Props = {};

const index = (props: Props) => {
  const { user } = useUser();
  return (
    <div>
      <MainHeader />
      <div className="flex flex-row p-2">
        <nav
          className=" rounded-md overflow-hidden h-[90vh] overflow-y-scroll sticky top-2
        "
        >
          <MainNav />
        </nav>
        <main className=" p-5 my-2 mx-4 w-full ">
          <Routes>
            {" "}
            <Route path="/payment-methods" element={<PaymentMethods />} />
            <Route path="/languages" element={<Languages />} />
            <Route path="/features" element={<Features />} />
            <Route path="/features/add" element={<Features addNewFeature />} />
            <Route
              path="/features/edit/:id"
              element={<Features editFeature />}
            />
            <Route path="/questions" element={<Questions />} />
            <Route
              path="/questions/add"
              element={<Questions addNewQuestion />}
            />
            <Route
              path="/questions/edit/:id"
              element={<Questions editQuestion />}
            />
            <Route path="/betting-websites" element={<BettingWebsites />} />
            <Route
              path="/betting-websites/add"
              element={<BettingWebsites addNewWebsite />}
            />{" "}
            <Route
              path="/betting-websites/edit-ratings/:id"
              element={<BettingWebsites editRatings />}
            />{" "}
            <Route
              path="/betting-websites/edit-contacts/:id"
              element={<BettingWebsites editContacts />}
            />
            <Route
              path="/betting-websites/edit-languages/:id"
              element={<BettingWebsites editLanguages />}
            />
            <Route
              path="/betting-websites/edit-payment-gateways/:id"
              element={<BettingWebsites editGateways />}
            />{" "}
            <Route
              path="/betting-websites/edit-features/:id"
              element={<BettingWebsites editFeatures />}
            />
            <Route
              path="/betting-websites/edit/:id"
              element={<BettingWebsites edit />}
            />
            <Route
              path="/betting-websites/edit-title/:id"
              element={<BettingWebsites editTitle />}
            />{" "}
            <Route
              path="/betting-websites/edit-short-description/:id"
              element={<BettingWebsites editShortDescription />}
            />
            <Route
              path="/betting-websites/edit-long-description/:id"
              element={<BettingWebsites editLongDescription />}
            />
            <Route
              path="/betting-websites/edit-q-and-a/:id"
              element={<BettingWebsites editQAndA />}
            />{" "}
            <Route
              path="/betting-websites/edit-image/:id"
              element={<BettingWebsites editImage />}
            />{" "}
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/add" element={<Articles addNewArticle />} />
            <Route
              path="/articles/edit-title/:id"
              element={<Articles editArticle />}
            />
            <Route
              path="/articles/edit-keywords/:id"
              element={<Articles editKeywords />}
            />
            <Route
              path="/articles/edit-image/:id"
              element={<Articles editImage />}
            />
            <Route
              path="/articles/edit/:id"
              element={<Articles editContent />}
            />
            <Route path="/top10-articles" element={<Top10Articles />} />
            <Route
              path="/top10-articles/add"
              element={<Top10Articles addNewArticle />}
            />
            <Route
              path="/top10-articles/edit-title/:id"
              element={<Top10Articles editArticleTitle />}
            />
            <Route
              path="/top10-articles/edit-keywords/:id"
              element={<Top10Articles editKeywords />}
            />
            <Route
              path="/top10-articles/edit/:id"
              element={<Top10Articles edit />}
            />
            <Route
              path="/top10-articles/edit-description/:id"
              element={<Top10Articles editArticleDescription />}
            />
            <Route
              path="/top10-articles/manage-rich-text/:id"
              element={<Top10Articles manageRichText />}
            />
            <Route
              path="/top10-articles/manage-rich-text/:id/add"
              element={<Top10Articles manageRichText addRichText />}
            />
            <Route
              path="/top10-articles/manage-rich-text/:id/edit/:richtextid"
              element={<Top10Articles manageRichText editRichText />}
            />
            <Route
              path="/top10-articles/edit-image/:id"
              element={<Top10Articles editImage />}
            />{" "}
            <Route
              path="/top10-articles/edit-top10-websites/:id"
              element={<Top10Articles editTop10Wbsites />}
            />
            <Route
              path="/top10-articles/edit-sorted-items/:id"
              element={<Top10Articles sortContent />}
            />
            <Route path="/main-websites" element={<MainWebsites />} />
            <Route
              path="/main-websites/add"
              element={<MainWebsites addNewMainWebsite />}
            />
            <Route
              path="/main-websites/edit-title/:id"
              element={<MainWebsites editMainWebsiteTitle />}
            />
            <Route
              path="/main-websites/edit-keywords/:id"
              element={<MainWebsites editKeywords />}
            />
            <Route
              path="/main-websites/edit/:id"
              element={<MainWebsites edit />}
            />
            <Route
              path="/main-websites/edit-description/:id"
              element={<MainWebsites editMainWebsiteDescription />}
            />
            <Route
              path="/main-websites/edit-image/:id"
              element={<MainWebsites editImage />}
            />
            <Route
              path="/main-websites/manage-categories/:id"
              element={<MainWebsites manageCategories />}
            />{" "}
            <Route
              path="/main-websites/manage-homepage/:id"
              element={<MainWebsites editHomepage />}
            />
            <Route
              path="/main-websites/manage-categories/:id/add"
              element={<MainWebsites manageCategories addNewCategory />}
            />
            <Route
              path="/main-websites/manage-categories/:id/edit-image/:categoryId"
              element={<MainWebsites manageCategories editCategoryImage />}
            />
            <Route
              path="/main-websites/manage-categories/:id/edit-title/:categoryId"
              element={<MainWebsites manageCategories editCategoryTitle />}
            />
            <Route
              path="/main-websites/manage-categories/:id/edit-keywords/:categoryId"
              element={<MainWebsites manageCategories editCategoryKeywords />}
            />{" "}
            <Route
              path="/main-websites/manage-categories/:id/edit/:categoryId"
              element={<MainWebsites manageCategories editCategory />}
            />{" "}
            <Route
              path="/main-websites/manage-categories/:id/edit-description/:categoryId"
              element={
                <MainWebsites manageCategories editCategoryDescription />
              }
            />{" "}
            <Route
              path="/main-websites/manage-categories/:id/edit-top-10-articles/:categoryId"
              element={<MainWebsites manageCategories editCategoryTop10 />}
            />
            <Route
              path="/main-websites/manage-categories/:id/manage-rich-text/:categoryId"
              element={<MainWebsites manageCategories manageCategoryRichText />}
            />{" "}
            <Route
              path="/main-websites/manage-categories/:id/manage-rich-text/:categoryId/add"
              element={
                <MainWebsites
                  manageCategories
                  manageCategoryRichText
                  addNewRichText
                />
              }
            />{" "}
            <Route
              path="/main-websites/manage-categories/:id/manage-rich-text/:categoryId/edit-rich-text/:richtextid"
              element={
                <MainWebsites
                  manageCategories
                  manageCategoryRichText
                  editRichText
                />
              }
            />{" "}
            <Route
              path="/main-websites/manage-categories/:id/sort-items/:categoryId"
              element={<MainWebsites manageCategories sortItems />}
            />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default index;
